<template>
    <div>
        <div class="day">
            <div class="left-day" @click="calendar">
                <img :src="$global.Image.month" alt="" />
                <div>{{ monthIndex + 1 }}月</div>
            </div>
            <div class="right-day" id="right-day">
                <div
                    class="li"
                    v-for="(item, index) in dataList"
                    :key="index"
                    @click="selectDay(index,apply)"
                >
                    <div
                        :class="
                            dayIndex == index ? 'number activies' : 'number'
                        "
                    >
                        {{ item.day }}
                    </div>
                    <div class="txt">{{ item.week }}</div>
                </div>
            </div>
        </div>
        <div class="select-time" v-if="show">
            <div class="left">
                <ul>
                    <li
                        v-for="(item, index) in year"
                        :key="index"
                        @click="selectYear(index)"
                        :class="yearIndex == index ? 'activies' : ''"
                    >
                        {{ item }}年
                    </li>
                </ul>
            </div>
            <div class="right">
                <div
                    class="number"
                    v-for="(item, index) in 12"
                    :key="index"
                    @click="selectMonth(index)"
                >
                    <div :class="index == monthIndex ? 'activies' : ''">
                        {{ index + 1 }}
                    </div>
                </div>
            </div>
        </div>
        <div class="time">
            <ul class="uu">
                <li v-for="(item, index) in 24" :key="index">
                    <div>{{ index }}:00</div>
                </li>
            </ul>
            <div class="lk">
                <ul>
                    <li
                        v-for="(item, index) in apply.data4"
                        :key="index"
                        :style="item.status ? 'background:#cccccc;border:1px solid #cccccc;':''"
                        :class="
                            item.type == 2
                                ? 'active2'
                                : item.type == 3
                                ? 'active3'
                                : item.type==4 ? 'active4':''
                        "
                        @click="
                            selectTime($event, item.type, item.time, apply,item.status,status)
                        " 
                    ></li>
                </ul>
                <ul>
                    <li
                        v-for="(item, index) in apply.data"
                        :key="index"
                        :style="item.status ? 'background:#cccccc;border:1px solid #cccccc;':''"

                        :class="
                            item.type == 2
                                ? 'active2'
                                : item.type == 3
                                ? 'active3'
                                : item.type==4 ? 'active4':''
                        "
                        @click="
                            selectTime($event, item.type, item.time, apply,item.status,status)
                        "
                    ></li>
                </ul>
                <ul>
                    <li
                        v-for="(item, index) in apply.data2"
                        :key="index"
                        :style="item.status ? 'background:#cccccc;border:1px solid #cccccc;':''"

                        :class="
                            item.type == 2
                                ? 'active2'
                                : item.type == 3
                                ? 'active3'
                                : item.type==4 ? 'active4':''
                        "
                         @click="
                            selectTime($event, item.type, item.time, apply,item.status,status)
                        "
                    ></li>
                </ul>
                <ul>
                    <li
                        v-for="(item, index) in apply.data3"
                        :key="index"
                        :style="item.status ? 'background:#cccccc;border:1px solid #cccccc;':''"

                        :class="
                            item.type == 2
                                ? 'active2'
                                : item.type == 3
                                ? 'active3'
                                : item.type==4 ? 'active4':''
                        "
                         @click="
                            selectTime($event, item.type, item.time, apply,item.status,status)
                        "
                    ></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "month",
    props: {
        apply: Object,
        status:Number
    },
    data() {
        return {
            year: [
                "2020",
                "2021",
                "2022",
                "2023",
                "2024",
                "2025",
                "2026",
                "2027"
            ],
            yearIndex: 0,
            monthIndex: 0,
            dayIndex: 0,
            minIndex: 0,
            show: false,
            dataList: [],
            time: "",
            dataListOne: [],
            timeStatus: 0,
            startTime: "",
            endTime: "",
            lastTime:"",
            allStartTime:'',
            allEndTime:'',
            endTimeSky:'',
            monthSelectIndex:0
        };
    },
    methods: {
        selectYear(e) {
            this.yearIndex = e;
            this.time =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex);
        },
        transformation(item) {
            if (item < 9) {
                item = "0" + (item + 1);
            } else {
                item = item + 1;
            }
            return item;
        },
        selectMonth(e) {
            this.monthIndex = e;
            this.show = false;
            this.monthSelectIndex=0
            this.time =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex);
            this.$emit("findTime", this.time);
            this.choose();
        },
        calendar() {
            if(this.monthSelectIndex==0){
                this.monthSelectIndex=1
            this.show = true;
            }else{
                this.monthSelectIndex=0
            this.show = false;

            }
        },
        selectDay(e,apply) {
            this.dayIndex = e;
            this.time =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex);
                this.$emit("findTime", this.time);
                /**清空时间值 */
                this.startTime='';
                this.endTime='';
                this.lastTime='';
                this.timeStatus=0;
        },
        /**判断某一天是星期几*/
        choose() {
            /**判断每年有多少天 */
            let days = [31, 28, 31, 30, 31, 30, 31, 30, 30, 31, 30, 31];
            /**判断闰年 */
            if (
                this.year % 4 === 0 &&
                (this.year % 100 !== 0 || this.year % 400 === 0)
            ) {
                days[1] = 29;
            }

            let selectYear = this.year[this.yearIndex]; //当前选中的年份
            let selectMonth = this.monthIndex + 1; //当前选中的月份
            let dataList = [];
            if (selectMonth < 10) {
                selectMonth = "0" + selectMonth;
            }
            for (var i = 0; i < days[this.monthIndex]; i++) {
                dataList.push({
                    day: i + 1,
                    week: this.week(
                        selectMonth,
                        i + 1,
                        this.year[this.yearIndex]
                    )
                });
            }
            this.dataList = dataList;
            // console.log(dataList);
        },
        week(month, day1, year) {
            if (day1 < 10) {
                day1 = "0" + day1;
            }
            var date = `${month}/${day1}/${year}`;
            // console.log(date);
            var day = new Date(Date.parse(date));
            var today = new Array(
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六"
            );
            var week = today[day.getDay()];
            return week;
        },
        /**选择时间段 */
        selectTime(e, type, time, timelist,status,tt) {
            if(tt==1){
                return
            }
            if (type == 2 || type==3) {
                this.$toast("当前时间已被占用");
                return;
            }
            if(status){
                this.$toast('当前时间无法选择')
                return
            }
            if (this.timeStatus == 0) {
                if (e.target.className.indexOf("activies") == -1) {
                    e.target.className = "activies";
                    this.timeStatus = 1;
                    this.startTime = time;
                } 
            } else {
                    this.endTime = time;
                 if(this.endTime==this.startTime){
                        e.target.className = "";
                        this.timeStatus=0;
                }else if(this.startTime==''){
                    e.target.className = "";
                        this.timeStatus=0;
                }
            }
            /**求两个时间段的值 */
            // if(this.endTime==''){
            //     return
            // }
            /**转成时间戳 */
            let startTimer =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex) +
                " " +
                this.startTime;
            let endTimer =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex) +
                " " +
                this.endTime;
            let lastTimer =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex) +
                " " +
                this.lastTime;
                // if(this.startTime!='' && this.endTime!=''){
                // startTimer=this.startTimeSky
                // endTimer=this.endTimeSky
                // lastTimer=this.endTimeSky
                // }
            var startDate = new Date(startTimer).getTime();
            var endDate=new Date(endTimer).getTime();
            var lastDate=new Date(lastTimer).getTime();
            var number=0
            console.log("starttime:",this.startTime,"endTime:"+this.endTime)
            this.allStartTime=this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +this.startTime
            this.allEndTime=this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +this.endTime
            /**保留最大值 */
            if(startDate>endDate && this.startTime!=''){
                if(lastDate>=startDate){
                    
                }else{
                this.lastTime=this.startTime
                console.log("11=>",this.lastTime)
            
                }
                }else{
                this.lastTime=this.endTime
                console.log("22=>",this.lastTime)
            }
            if(startDate>endDate){
                // this.lastTime=this.startTime
                this.endTime=this.lastTime
                this.startTime=time
            console.log("starttime__:",this.startTime,"endTime__:"+this.endTime,"last_time__",this.lastTime)           
            this.allStartTime=this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +this.startTime
            this.allEndTime=this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +this.endTime
                let startTimer =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex) +
                " " +
                this.startTime;
            let endTimer =
                this.year[this.yearIndex] +
                "-" +
                this.transformation(this.monthIndex) +
                "-" +
                this.transformation(this.dayIndex) +
                " " +
                this.endTime;
             startDate = new Date(startTimer).getTime();
             endDate=new Date(endTimer).getTime();
            // startDate=new Date(this.startTimeSky).getTime()
            // endDate=new Date(this.endTimeSky).getTime()
            }
            // console.log(timelist)
            for(var i in timelist.data){
                let da=new Date(this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +timelist.data[i].time).getTime()
                if(endDate>=da && startDate<=da){
                    if(timelist.data[i].type==2 || timelist.data[i].type==3){
                        ++number                        
                    }else{
                    timelist.data[i].type=4
                    }
                }else{
                    if(timelist.data[i].type==2 || timelist.data[i].type==3){
                        timelist.data[i].type=timelist.data[i].type
                    }else{
                   timelist.data[i].type=1  
                    }
                }
            }
            
            for(var i in timelist.data2){
                let da=new Date(this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +timelist.data2[i].time).getTime()
                if(endDate>=da && startDate<=da){
                    if(timelist.data2[i].type==2 || timelist.data2[i].type==3){
                        ++number
                    }else{
                    timelist.data2[i].type=4
                    }
                }else{
                  if(timelist.data2[i].type==2 || timelist.data2[i].type==3){
                        timelist.data2[i].type=timelist.data2[i].type
                    }else{
                   timelist.data2[i].type=1  
                    }
                }
            }
            for(var i in timelist.data3){
                let da=new Date(this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +timelist.data3[i].time).getTime()
                if(endDate>=da && startDate<=da){
                    if(timelist.data3[i].type==2 || timelist.data3[i].type==3){
                        ++number                        
                    }else{
                    timelist.data3[i].type=4
                    }
                }else{
                   if(timelist.data3[i].type==2 || timelist.data3[i].type==3){
                        timelist.data3[i].type=timelist.data3[i].type
                    }else{
                   timelist.data3[i].type=1  
                    }
                }

            }
            for(var i in timelist.data4){
                let da=new Date(this.year[this.yearIndex] +"-" +this.transformation(this.monthIndex) +"-" +this.transformation(this.dayIndex) +" " +timelist.data4[i].time).getTime()
                 if(endDate>=da && startDate<=da){
                    if(timelist.data4[i].type==2 || timelist.data4[i].type==3){
                        ++number                        
                    }else{
                    timelist.data4[i].type=4
                    }
                }else{
                  if(timelist.data4[i].type==2 || timelist.data4[i].type==3){
                        timelist.data4[i].type=timelist.data4[i].type
                    }else{
                   timelist.data4[i].type=1  
                    }
                }

            }
            /**判断时间是否被占用 */
            if(number>0){
               for(var j in timelist.data){
                        if(timelist.data[j].type==4){
                            timelist.data[j].type=1
                        }
                    }
                for(var j in timelist.data2){
                        if(timelist.data2[j].type==4){
                            timelist.data2[j].type=1
                        }
                    }
                for(var j in timelist.data3){
                        if(timelist.data3[j].type==4){
                            timelist.data3[j].type=1
                        }
                    }
                for(var j in timelist.data4){
                        if(timelist.data4[j].type==4){
                            timelist.data4[j].type=1
                        }
                    }
                this.$toast('选择的时间段有被占用的，请重新选择')    
                this.startTime=this.endTime
                // this.startTime=''
                this.endTime=''
                this.lastTime=''
                this.timeStatus=0
            }
            let data={
                allStartTime:this.allStartTime,
                allEndTime:this.allEndTime
            }
            this.$emit('all',data)
        },
        lookTime() {
            var myDate = new Date();
            var tMonth = myDate.getMonth();
            var tYear = myDate.getFullYear();
            var tday = myDate.getDate();
            let data = [];
            for (var i = 0; i < 5; i++) {
                if(i==0){
                tYear = tYear;
                }else{
                tYear = tYear + 1;
                }
                data.push(tYear);
            }
            this.year = data;
            this.monthIndex = tMonth;
            this.dayIndex = tday - 1;
            if(this.dayIndex>=14 && this.dayIndex<17){
                this.$nextTick(() => {
                    document.getElementById("right-day").scrollLeft=700
                })
            }else if(this.dayIndex>=17){
                this.$nextTick(() => {
                    document.getElementById("right-day").scrollLeft=1100
                })
            }
        }
    },
    mounted() {
        this.lookTime();
        this.choose();

    }
};
</script>
<style lang="less" scoped>
.day {
    width: 754px;
    height: 68px;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    box-shadow: 0px 0px 4px 0px #e6e8ed;
    display: flex;
    margin-left: 20px;
    .left-day {
        width: 55px;
        height: 68px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 15px;
            height: 15px;
        }
        > div {
            padding-top: 6px;
            font-size: 15px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: center;
            color: #333333;
        }
    }
    .right-day {
        display: -webkit-box;
        height: 68px;
        width: 754px;
        overflow-x: scroll;
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px #e6e8ed;
        .li {
            width: 50px;
            display: flex;
            height: 100%;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .number {
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                color: #333333;
                border-radius: 50%;
            }
            .activies {
                background: #3449d3;
                color: #ffffff;
            }
            .txt {
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #333333;
                padding-top: 2px;
            }
        }
    }
    // .right-day::-webkit-scrollbar {display:none}
}
.time {
    width: 754px;
    height: 202px;
    background: #f9fafc;
    border-radius: 0px 0px 10px 10px;
    overflow-x: scroll;
    margin-top: 3px;
    margin-left: 20px;
    cursor: pointer;
    .uu {
        display: flex;
        width: 100%;
        height: 46px;
        align-items: center;
        border-bottom: 1px dashed #d8ddef;

        li {
            text-align: center;
            margin-right: 9px;
            width: 43px;
            > div {
                display: block;
                width: 43px;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #333333;
            }
        }
        .activies {
            background: #3449d3;
            border-radius: 30px;
            > div {
                color: #ffffff !important;
            }
        }
    }
    .lk {
        width: 100%;
        ul {
            display: -webkit-box;
            width: 100%;
            height: 20px;
            margin-top: 10px;
            li {
                width: 43px;
                height: 20px;
                margin-right: 7px;
                border: 1px solid #919cc6;
                border-radius: 13px;
            }
            .activies {
                background: #31be94;
            }
            .active2 {
                background: #f5b80c;
                border: 1px solid #f5b80c;
            }
            .active3 {
                background: #6480ec;
                border: 1px solid #6480ec;
            }
            .active4 {
                background: #31be94;
                border: 1px solid #31be94;
            }
        }
    }
}
.select-time {
    display: flex;
    width: 186px;
    height: 121px;
    background: #ffffff;
    box-shadow: 0px 4px 5px 0px #eceef0;
    align-items: center;
    margin-left: 20px;
    position: absolute;
    .left {
        width: 75px;
        height: 118px;
        background: #ffffff;
        overflow-y: scroll;
        box-shadow: 1px 1px 10px 1px #cccccc;
        ul {
            li {
                width: 55px;
                height: 23px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                background: #ffffff;
                color: #999999;
                font-size: 12px;
                cursor: pointer;
            }
            .activies {
                width: 55px;
                height: 23px;
                background: #3449d3;
                color: #ffffff;
                font-size: 13px;
            }
        }
    }
    .right {
        width: 131px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        justify-content: center;
        .number {
            width: 25%;
            height: 40px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            > div {
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                background: #edeffb;
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #333333;
                border-radius: 50%;
            }
            .activies {
                background: #3449d3;
                color: #ffffff;
            }
        }
    }
}
</style>
